import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core'
import { Router } from '@angular/router'
import {
  DataContextBuilder,
  ElderBasicPaneLayoutComponent,
  ElderDataToolbarComponent,
  ElderPaneComponent,
  ElderSearchBoxComponent,
  ElderSearchContextDirective,
  ElderTableComponent,
  ElderTableToolbarDirective,
  ElderToolbarContentDirective,
  IDataContext,
} from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { Property } from '../../../properties/property'
import { BatchTracingSpec } from '../batch-tracing-spec'
import { BatchTracingSpecService } from '../batch-tracing-spec.service'

import { MatChip, MatChipSet } from '@angular/material/chips'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'

@Component({
  selector: 'app-batch-tracing-spec-browser',
  templateUrl: './batch-tracing-spec-browser.component.html',
  styleUrls: ['./batch-tracing-spec-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    ElderToolbarContentDirective,
    ElderSearchBoxComponent,
    ElderSearchContextDirective,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    MatChipSet,
    MatChip,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class BatchTracingSpecBrowserComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private router = inject(Router)
  private tracingSpecService = inject(BatchTracingSpecService)

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly data: IDataContext<BatchTracingSpec>

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.data = DataContextBuilder.start<BatchTracingSpec>()
      .pageSize(30)
      .reloadOnLocalChanges()
      .autoStartAsap()
      .build(this.tracingSpecService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openDetail(property: Property): void {
    this.router.navigate([{ outlets: { side: ['batch-tracing-specs', property.id] } }], {
      preserveFragment: true,
    })
  }

  public create(): void {
    this.router.navigate([{ outlets: { side: ['batch-tracing-specs', 'new'] } }], {
      preserveFragment: true,
    })
  }
}
